export default __webpack_public_path__ + "static/bookNowHeader-236f137ba1bd044eecaa89bf57daecaf.jpg";